angular.module('autoremind.dashboard.directives')
    .directive('birthdayWidget', ['$rootScope', '$parse', '$interval', '$location', 'messagesService', '$timeout',
    function ($rootScope, $parse, $interval, $location, messagesService, $timeout) {
        return {
            templateUrl: 'app/dashboard/widgets/birthday/birthday.html',
            scope: true,
            link: function (scope, elem, attr) {
                scope.params = $parse(attr.params)(scope);
                scope.viewModel = {
                    stats: {
                        todayTotalSent: null
                    },
                    updateInterval: angular.isDefined(scope.params.settings) && angular.isDefined(scope.params.settings.updateInterval) ? scope.params.settings.updateInterval : false,
                    isBusy: false
                };
                scope.timer = null;
                scope.timerStopped = undefined;
                scope.getBirthdayStats = function () {
                    if (scope.viewModel.isBusy) {
                        console.log('Busy already getting birthday messages today stats!');
                        return;
                    }
                    console.log('Get birthday messages today stats');
                    scope.viewModel.isBusy = true;
                    messagesService.getMessagesTodayStats('birthday')
                        .then(function (data) {
                        console.log('Got BIRTDAY messages today stats');
                        scope.viewModel.isBusy = false;
                        if (!scope.timerStopped) {
                            if (angular.isDefined(data.stats.todayTotalSent)) {
                                scope.viewModel.stats.todayTotalSent = data.stats.todayTotalSent;
                            }
                            if (scope.viewModel.updateInterval) {
                                console.log('Schedule to get birthday messages today stats in ' + scope.viewModel.updateInterval + 'ms');
                                scope.timer = $timeout(function () {
                                    scope.getBirthdayStats();
                                }, Math.abs(scope.viewModel.updateInterval));
                            }
                        }
                    }, function () {
                        scope.viewModel.isBusy = false;
                        if (!scope.timerStopped) {
                            console.log('Failed getting BIRTHDAY messages today stats... Try again in 10 minutes or click the widget');
                            scope.timer = $timeout(function () {
                                scope.getBirthdayStats();
                            }, 10 * 60 * 1000); // Cooldown on errors
                        }
                    });
                };
                scope.refresh = function () {
                    scope.getBirthdayStats();
                };
                scope.stopTimer = function () {
                    scope.timerStopped = true;
                    console.log('Dashboard stopped polling BIRTHDAY stats');
                    if (scope.timer) {
                        $timeout.cancel(scope.timer);
                    }
                };
                scope.$on("$locationChangeStart", function (event, next, current) {
                    scope.stopTimer();
                });
                $rootScope.$on('event:auth-logout', function () {
                    scope.stopTimer();
                });
                scope.$on('$destroy', function () {
                    console.log("destroy BIRTHDAY widget");
                    scope.stopTimer();
                });
                scope.getBirthdayStats();
            }
        };
    }]);
//# sourceMappingURL=birthday.directive.js.map